<ngx-spinner
  bdColor="rgb(63,69,95)"
  size="medium"
  color="#0af0d5"
  type="ball-scale-pulse"
  [fullScreen]="true"
>
  <p style="color: white"></p>
</ngx-spinner>
